import moment from 'moment';
import { apolloClient } from '@/apollo';

let lastRefresh = moment();

const hookAppFocusEvent = () => {
  window.addEventListener('focus', () => {
    if (moment().diff(lastRefresh, 'minutes') >= 30) {
      apolloClient.queryManager.refetchQueryByName('DaysQuery');
      apolloClient.queryManager.refetchQueryByName('DayDishesQuery');
      lastRefresh = moment();
    }
  }, false);
};

hookAppFocusEvent();
